import { SuperDashboardContextProvider } from "../../superAdmin/superdashboard/context/SuperDashboardContext";
import { CompanyFilterContextProvider } from "../../superAdmin/components/context/CompanyFilterContext";
import SuperDashboard from "../../superAdmin/superdashboard/SuperDashboard";

const DASHBOARD_FILTER_CONFIG = {
    tiers: true,
    status: true,
    executive: true,
    companies: true,
    dateRange: true,
};

const SuperDashboardPage = () => {
    return (
        <CompanyFilterContextProvider filterConfig={DASHBOARD_FILTER_CONFIG}>
            <SuperDashboardContextProvider>
                <SuperDashboard />
            </SuperDashboardContextProvider>
        </CompanyFilterContextProvider>
    );
};

export default SuperDashboardPage;
